/*
 * File: tabs.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-23 10:47:40
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { PropInnateSync } from "@root/core/vue-props";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Tabs extends BaseComponent {
    /// public props
    // tab selected
    @PropInnateSync("value", { type: Number, default: 0 })
    innateValue!: number;

    // rounded button
    @Prop({ type: Boolean, default: false })
    pills!: boolean;

    // fill the row
    @Prop({ type: Boolean, default: false })
    fill!: boolean;

    // fill the row with justify width
    @Prop({ type: Boolean, default: false })
    justify!: boolean;

    // vertical tabs
    @Prop({ type: Boolean, default: false })
    vertical!: boolean;

    // tabs at the end rather in the front
    @Prop({ type: Boolean, default: false })
    end!: boolean;

    /// available slots /////////////////////
    publicSlots = {
        toolbox: "@toolbox",
    };

    /// private helper
    hasCardParent() {
        const vNode = this.$parent?.$vnode;
        if (vNode == undefined) return false;
        if (vNode.componentOptions && vNode.componentOptions.Ctor.name === "Card") {
            return true;
        }
        return false;
    }
}
